import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { AllInterviewResponseModel, InterviewReportResponse, InterviewResponseModel, ResponseObjectForRecruitment } from '@gtpl/shared-models/hrms';

import { Body, Controller, Post } from '@nestjs/common';

import { onErrorResumeNext } from 'rxjs/operators';

import { InterviewService } from './interview.service';

import { interviewDTO } from './dto/interview.dto';
import { interviewRequest } from './dto/interview.request';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { IdRequest } from './dto/idRequest';
import { unitreq } from './dto/unitreq';

@Controller('interview')
export class InterviewController {
    constructor(
        private service: InterviewService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) { }
    @Post('/createinterview')
    async createinterview(@Body() DTO: interviewDTO, isUpdate: boolean = false): Promise<InterviewResponseModel> {
        try {
            return await this.service.createinterview(DTO, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(InterviewResponseModel, error);
        }
    }

    @Post('/updateinterview')
    async updateinterview(@Body() DTO: interviewDTO, isUpdate: boolean = false): Promise<InterviewResponseModel> {
        try {
            return await this.service.createinterview(DTO, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(InterviewResponseModel, error);
        }
    }

    @Post('/getAllinterview')
    async getAllinterview(): Promise<AllInterviewResponseModel> {
        try {
            return await this.service.getAllinterview();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllInterviewResponseModel, error);
        }
    }

    @Post('/getAllActiveinterview')
    async getAllActiveinterview(): Promise<AllInterviewResponseModel> {
        try {
            return await this.service.getAllActiveinterview();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllInterviewResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateinterview')
    async activateOrDeactivate(@Body() req: interviewRequest): Promise<InterviewResponseModel> {
        try {
            return await this.service.activateOrDeactivateinterview(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(InterviewResponseModel, error)
        }
    }


    @Post("/getInterviewReportingData")
    async getInterviewReportingData(): Promise<InterviewReportResponse> {
        try {
            return await this.service.getInterviewReportingData()
        } catch (error) {
            return this.applicationExceptionHandler.returnException(InterviewReportResponse, error)
        }

    }


    @Post("/getRecruitmentData")
    async getRecruitmentData(): Promise<ResponseObjectForRecruitment> {
        try {
            return await this.service.getRecruitmentData()
        } catch (error) {
          
            return this.applicationExceptionHandler.returnException(ResponseObjectForRecruitment, error)
        }

    }

    @Post("/getIDJob")
    async getIDJob( ): Promise<CommonResponse> {
        try {
            return await this.service.getIDJob()
        } catch (error) {
          
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }

    }

    @Post("/getRecruitmentDataForUnit")
    async getRecruitmentDataForUnit(@Body() req:unitreq): Promise<ResponseObjectForRecruitment> {
        try {
            return await this.service.getRecruitmentDataForUnit(req)
        } catch (error) {
          
            return this.applicationExceptionHandler.returnException(ResponseObjectForRecruitment, error)
        }

    }


}







